/*
 * Where: src/app/App.js
 * What: Application root that resolves routes and page components.
 * Why: Keep react-router-dom based page routing centralized.
 */
import React from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';
import MainLayout from '../layouts/MainLayout';
import { ROUTE_PATHS } from '../constants/routes';
import HowToUsePage from '../pages/HowToUsePage';
import IndexPage from '../pages/IndexPage';
import NotFoundPage from '../pages/NotFoundPage';
import ReadPage from '../pages/ReadPage';

function App() {
    const location = useLocation();
    const navigate = useNavigate();

    const currentPath = (() => {
        if (location.pathname === ROUTE_PATHS.root) {
            return ROUTE_PATHS.top;
        }
        if (location.pathname === ROUTE_PATHS.howToUseAlias) {
            return ROUTE_PATHS.howToUse;
        }
        if (location.pathname === ROUTE_PATHS.readAlias) {
            return ROUTE_PATHS.read;
        }
        return location.pathname;
    })();

    const handleNavigate = (nextPath) => {
        navigate(nextPath);
    };

    return (
        <MainLayout currentPath={currentPath} onNavigate={handleNavigate}>
            <Routes>
                <Route
                    path={ROUTE_PATHS.root}
                    element={<Navigate to={ROUTE_PATHS.top} replace />}
                />
                <Route path={ROUTE_PATHS.top} element={<IndexPage />} />
                <Route path={ROUTE_PATHS.howToUse} element={<HowToUsePage />} />
                <Route path={ROUTE_PATHS.howToUseAlias} element={<HowToUsePage />} />
                <Route path={ROUTE_PATHS.read} element={<ReadPage />} />
                <Route path={ROUTE_PATHS.readAlias} element={<ReadPage />} />
                <Route path="*" element={<NotFoundPage onNavigate={handleNavigate} />} />
            </Routes>
        </MainLayout>
    );
}

export default App;
